// unit.store.ts
import { createEntityStore } from "@/core/factory/store"
import { Unit, UNIT_ENTITY, createEmptyUnit } from "@/features/risks/entities/unit/model/unit.types"
import { createSelector } from "@reduxjs/toolkit"
import { Job } from "../../job/model/job.types"
import { setJobsForUnit, fetchOneWithJobs } from "./unit.thunk"
import { noContext } from "@/core/utils/noContext"

export const createUnitStore = () => {
  const base = createEntityStore<Unit, null>(UNIT_ENTITY, createEmptyUnit, noContext)

  const selectJobsOfActiveUnit = createSelector([(s: any) => s.unit.active, (s: any) => s.job.list], (unit, jobs) => {
    if (!unit) return []
    if (!unit.JobIds?.length) return []
    return jobs.filter((j: Job) => unit.JobIds.includes(j.id))
  })

  return {
    ...base,
    actions: {
      ...base.actions
    },
    selectors: {
      ...base.selectors,
      jobsOfActiveUnit: selectJobsOfActiveUnit
    },
    thunks: {
      ...base.thunks,
      fetchOneWithJobs,
      setJobsForUnit
    }
  }
}

const unitStore = createUnitStore()
export default unitStore
